import {Injectable} from '@angular/core';
import {IdexService} from '../idex.service';
import {UserData} from './user-company/user-company.component';

export class Company {
   id: number;
   name: string;
   tin: string;
   status: string;
   cellphone: string;
   creator: string;
   created: string;
   approval: string;
   isCompany: boolean;
}

export class Site {
   id: number;
   tin: string;
   siteName: string;
   siteCode: string;
   createdBy: string;
   createdDate: string;
   updateBy: string;
   updateDate: string;
   isDeleted: boolean;
   members: UserData[];
}

@Injectable({providedIn: 'root'})
export class AdminApi {
   constructor(private service: IdexService) {
   }

   listCompany(params: any) {
      return this.service.get('company/list', {params});
   }

   listSite(params: any, username: any) {
      return this.service.get('site/list', {params}, {isBody: true,data: username});
   }

   findSite(params: any,ids: any[]) {
      return this.service.post('site/find', ids, {params});
   }

   listGroup(params: any) {
      return this.service.get('site/groups', {params});
   }

   addUserGroup(groupName: string,userName: string) {
      return this.service.post(`admin/group-user/${groupName}/${userName}`);
   }

   listAlfrescoSite(searchText?: string) {
      let resp;
      if(searchText){
         resp = this.service.get('site/alfresco/list?searchText=' + encodeURIComponent(searchText));
      } else {
         resp = this.service.get('site/alfresco/list');
      }
      return resp;
   }

   createSite(data: any) {
      return this.service.post('site/create', data, {responseType: 'text'});
   }

   updateSite(data: any) {
      return this.service.put('site/update', data, {responseType: 'text'});
   }

   addSites(data: Site[]) {
      return this.service.post('site/add', data, {responseType: 'text'});
   }

   deleteSite(sites: string[]) {
      return this.service.post('site/delete', sites, {responseType: 'text'});
   }

   getQuota(username: string) {
      const uname = encodeURIComponent(username);
      return this.service.get(`site/member/quota/${uname}`);
   }

   updateQuota(username: string, size: number) {
      const uname = encodeURIComponent(username);
      return new Promise<void>((resolve, reject) => {
         this.service.post(`site/user/quota/${uname}?size=${size}`).subscribe(res => {
            resolve(res);
         }
         ,error => {
            reject(error);
         });
      });
   }

   addToSite(username: string, siteCode: string, isMember: boolean) {
      const uname = encodeURIComponent(username);
      return new Promise<void>((resolve, reject) => {
         this.service.post('/work/' + siteCode + '/team/' + username + '/member?u=' + isMember).subscribe(res => {
            resolve(res);
         }
         ,error => {
            reject(error);
         });
      });
   }

   addToGroup(groupName: string, username: string) {
      const uname = encodeURIComponent(username);
      return new Promise<void>((resolve, reject) => {
         this.service.post(`site/group/${groupName}/${username}`).subscribe(res => {
            resolve(res);
         }
         ,error => {
            reject(error);
         });
      });
   }

   getProfile(username: string,tin: string) {
      const uname = encodeURIComponent(username);
      return this.service.get(`site/member/profile/${tin}/${uname}`);
   }

   getRole(username: string,tin: string) {
      const uname = encodeURIComponent(username);
      return this.service.get(`site/member/role/${tin}/${uname}`);
   }

   listPdfTemplate(tin: string, filterValue: string, orderBy: any, orderType: any, index: any, size: any, params: any) {
      return this.service.get('/pdf-template/' + tin + '?searchText=' + filterValue + '&orderBy=' + orderBy +
         '&orderType=' + orderType + '&index=' + index + '&size=' + size, { params });
   }

   listPdfTemplateOnlyActive(tin: string, filterValue: string, orderBy: any, orderType: any, index: any, size: any, params: any) {
      return this.service.get('/pdf-template/active/' + tin + '?searchText=' + filterValue + '&orderBy=' + orderBy +
         '&orderType=' + orderType + '&index=' + index + '&size=' + size, { params });
   }

   newBlank(tin: string, name: string) {
      return this.service.get(`pdf-template/new/${tin}`, { params: { name: encodeURIComponent(name) } });
   }

   uploadPdfTemplate(file: any, tin: string) {
      const formData = new FormData();
      formData.append('file', file);
      return this.service.post('/pdf-template/upload/' + tin, formData);
   }

   createPdfTemplate(docId: string, data: any) {
      return this.service.post('/pdf-template/create/' + docId, data);
   }

   getPdfTemplate(docId: string) {
      return this.service.get('/pdf-template/' + docId + '/download', { responseType: 'arraybuffer' });
   }

   deleteTemplateList(templateId: number) {
      const url = 'pdf-template/delete/' + templateId;
      return this.service.put(url);
   }

   renamePdfTemplate(templateId: number, alfId: string, templateName: string) {
      return this.service.put(`pdf-template/rename/${templateId}`, {alfId, templateName});
   }

   activePdfTemplate(id: number, isActive: boolean) {
      return this.service.put('/pdf-template/active/' + id + '?isActive=' + isActive);
   }
}
